module.exports = __webpack_public_path__ + "static/img/blank.c6140756.png";